export interface MailProviderClient {
  provider: "gmail" | "outlook";
  getProfile(): Promise<{ emailAddress: string; historyId?: string }>;
  listMessagesWithAttachments(query?: string, pageToken?: string): Promise<{
    messages: NormalizedMessage[];
    attachments: NormalizedAttachment[];
    nextPageToken?: string;
  }>;
  fetchAttachment(messageId: string, attachmentId: string): Promise<Blob>;
}

export interface GmailClient extends MailProviderClient {
  listHistory(startHistoryId: string, pageToken?: string): Promise<{
    messages: NormalizedMessage[];
    attachments: NormalizedAttachment[];
    historyId?: string;
    nextPageToken?: string;
  }>;
}

export interface OutlookClient extends MailProviderClient {
  listDelta(deltaToken?: string): Promise<{
    messages: NormalizedMessage[];
    attachments: NormalizedAttachment[];
    deltaToken?: string;
    nextPageToken?: string;
  }>;
}

export interface NormalizedMessage {
  id: string;
  threadId: string;
  subject: string;
  snippet: string;
  senderEmail: string;
  senderName: string;
  receivedAt: string;
  labels: string[];
}

export interface NormalizedAttachment {
  messageId: string;
  attachmentId: string;
  filename: string;
  mimeType: string;
  size: number;
}

export class ProviderError extends Error {
  constructor(
    message: string,
    public readonly code: "token_expired" | "rate_limited" | "network" | "unknown"
  ) {
    super(message);
    this.name = "ProviderError";
  }
}
